<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">委托处置</h4>
      </div>
      <div
        style="margin-top:10px;display:flex;justify-content: space-between;line-height: 39px;"
        v-if="$route.query.type != 'modify' && !pageTypeCheck"
      >
        <el-upload
          class="upload-demo"
          :show-file-list="false"
          action=""
          :multiple="false"
          accept=".xlsx"
          :http-request="onRequest"
        >
          <el-button size="small" type="primary">批量上传</el-button>
        </el-upload>
        <div class="cell-link" @click="onMateTemplate">
          处置物资导入模板
        </div>
      </div>
      <el-form
        ref="form"
        :model="form"
        label-width="165px"
        size="small"
        :rules="FormRules"
        label-suffix=":"
      >
        <div v-for="(item, index) in form.sellerMateVOList" :key="index">
          <div class="titleone"></div>
          <div class="title">
            <p class="titlespan"></p>
            处置物资{{ index + 1
            }}<span
              class="titlesplic"
              v-if="index !== 0 && !pageTypeCheck"
              @click="onTitlesplic(index)"
              >删除</span
            >
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="所属分类:"
                :prop="'sellerMateVOList.' + index + '.className'"
                :rules="
                  !pageTypeCheck
                    ? [{ required: true, message: ' ', trigger: 'change' }]
                    : []
                "
              >
                <template slot="label">
                  所属分类
                  <el-tooltip effect="light" placement="top-start">
                    <template slot="content"> 公开 </template>
                    <i class="el-icon-question table-worming">&nbsp;</i>
                  </el-tooltip>
                  :
                </template>
                <span v-if="pageTypeCheck">{{ item.className }}</span>
                <el-cascader
                  v-else
                  ref="cascaderUnit"
                  class="sdcascader"
                  v-model="item.classNamearr"
                  :options="classNamearrOptions"
                  :props="{ checkStrictly: true }"
                  @change="handleChangeoptions(item, index)"
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="物资描述:"
                :prop="'sellerMateVOList.' + index + '.mateName'"
                :rules="
                  !pageTypeCheck
                    ? [{ required: true, message: ' ', trigger: 'change' }]
                    : []
                "
              >
                <template slot="label">
                  物资描述
                  <el-tooltip effect="light" placement="top-start">
                    <template slot="content"> 公开 </template>
                    <i class="el-icon-question table-worming">&nbsp;</i>
                  </el-tooltip>
                  :
                </template>
                <span v-if="pageTypeCheck">{{ item.mateName }}</span>
                <el-input
                  v-else
                  v-model="item.mateName"
                  @blur="onMateName(item.mateName)"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="2">
              <el-form-item
                label="预估数量:"
                :prop="'sellerMateVOList.' + index + '.fixedMateAmount'"
                :rules="
                  !pageTypeCheck
                    ? [{ required: true, message: ' ', trigger: 'blur' }]
                    : []
                "
              >
                <template slot="label">
                  预估数量
                  <el-tooltip effect="light" placement="top-start">
                    <template slot="content"
                      >公开，可输入未列出的计量单位
                    </template>
                    <i class="el-icon-question table-worming">&nbsp;</i>
                  </el-tooltip>
                  :
                </template>
                <span v-if="pageTypeCheck"
                  >{{ item.fixedMateAmount }}{{ item.unitName }}</span
                >
                <el-input
                  v-else
                  v-model="item.fixedMateAmount"
                  v-digits-limit="[10, 3]"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" style="margin-top:2px" v-if="!pageTypeCheck">
              <el-select
                v-model="item.unitName"
                placeholder="请选择"
                filterable
                allow-create
                size="small"
              >
                <el-option
                  v-for="item in unitOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>

          <el-form-item
            label="物资图片:"
            :prop="'sellerMateVOList.' + index + '.mateImgs'"
            :rules="
              !pageTypeCheck
                ? [
                    {
                      required: true,
                      message: '请至少添加一张图片',
                      trigger: 'change'
                    }
                  ]
                : []
            "
          >
            <template slot="label">
              物资图片
              <el-tooltip effect="light" placement="top-start">
                <template slot="content">
                  请从物资的正面、侧面、铭牌等多角度拍摄，公开，可上传jpeg、jpg、png、bmp格式图片，最多10张照片，每张照片不超过5M
                </template>
                <i class="el-icon-question table-worming">&nbsp;</i>
              </el-tooltip>
              :
            </template>
            <div class="img-list" v-if="pageTypeCheck">
              <div
                class="img-content group"
                v-for="(item1, index1) in item.mateImgs"
                :key="index1"
              >
                <img :src="item1.src" />
                <el-button
                  v-if="item.majorImageId === item1.fileId"
                  type="text"
                  class="text"
                  >主图</el-button
                >
                <!-- 放大icon -->
                <div class="layer" @click="handleFileEnlarge(item1.src)">
                  <i class="el-icon-view"></i>
                </div>
                <!-- <span @click='getUploadTag(item, index)' class="up_btns">{{item.up_btn}}</span> -->
              </div>
              <el-dialog
                title=""
                :visible.sync="isEnlargeImage"
                size="large"
                :modal-append-to-body="false"
                top="8%"
                width="50%"
              >
                <img
                  @click="isEnlargeImage = false"
                  style="width: 100%; height: 340px"
                  :src="enlargeImage"
                />
              </el-dialog>
            </div>
            <div class="img-list" v-else>
              <el-radio-group v-model="item.majorImageId">
                <div
                  class="img-content group"
                  v-for="(item1, index1) in item.mateImgs"
                  :key="index1"
                >
                  <img :src="item1.src" />
                  <!-- 放大icon -->
                  <div class="layer" @click="handleFileEnlarge(item1.src)">
                    <i class="el-icon-view"></i>
                  </div>
                  <!-- <span @click='getUploadTag(item, index)' class="up_btns">{{item.up_btn}}</span> -->
                  <el-radio :label="item1.fileId">主图</el-radio>
                  <el-button
                    type="text"
                    @click="handleFileRemove(index, index1)"
                    class="text"
                    >删除</el-button
                  >
                </div>
                <el-dialog
                  title=""
                  :visible.sync="isEnlargeImage"
                  size="large"
                  :modal-append-to-body="false"
                  top="8%"
                  width="50%"
                >
                  <img
                    @click="isEnlargeImage = false"
                    style="width: 100%;height:340px"
                    :src="enlargeImage"
                  />
                </el-dialog>
                <div class="group">
                  <el-upload
                    v-if="item.mateImgs.length !== 10"
                    multiple
                    :limit="10"
                    accept=".jpg,.png,.bmp,.jpeg"
                    action=""
                    :show-file-list="false"
                    :http-request="val => handleUploadFormImgs(val, index)"
                    list-type="picture-card"
                    :file-list="item.mateImgs"
                    :on-exceed="handleExceed"
                  >
                    <el-button type="text">点击上传</el-button>
                  </el-upload>
                </div>
              </el-radio-group>
            </div>
          </el-form-item>

          <el-form-item label="视频上传:" prop="Video">
            <template slot="label">
              视频上传
              <el-tooltip effect="light" placement="top-start">
                <template slot="content">
                  公开，可上传avi、wmv、mpeg、mp4、mov、mkv、flv、rmv格式视频，最大不超过50M
                </template>
                <i class="el-icon-question table-worming">&nbsp;</i>
              </el-tooltip>
              :
            </template>
            <div v-if="!pageTypeCheck">
              <el-upload
                class="avatar-uploader"
                :http-request="val => handleUploadForm(val, index)"
                action=""
                accept=".mp4,.qlv,.qsv,.ogg,.flv,.avi,.wmv,.rmvb"
                :show-file-list="false"
                id="video"
                :file-list="item.mateVideos"
              >
                <video
                  v-if="item.Video"
                  :src="item.mateVideos[0].src"
                  width="150"
                  height="100"
                  controls="controls"
                >
                  您的浏览器不支持视频播放
                </video>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <!--没选择视频之前显示-->
              </el-upload>
            </div>

            <el-button
              type="text"
              v-if="item.Video && !pageTypeCheck"
              @click="Videodelete(index)"
              >删除视频</el-button
            >
            <video
              v-if="item.Video && pageTypeCheck"
              :src="item.mateVideos[0].src"
              width="150"
              height="100"
              controls="controls"
            >
              您的浏览器不支持视频播放
            </video>
          </el-form-item>
          <el-form-item label="物资说明:">
            <template slot="label">
              物资说明
              <el-tooltip effect="light" placement="top-start">
                <template slot="content"
                  >请填写处置物资材质、尺寸、交货条件等物资现状，公开，不超过500字符
                </template>
                <i class="el-icon-question table-worming">&nbsp;</i>
              </el-tooltip>
              :
            </template>
            <span v-if="pageTypeCheck">{{ item.mateDescribe }}</span>
            <el-input
              v-else
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              placeholder="请填写处置物资材质、尺寸、交货条件等物资现状"
              v-model="item.mateDescribe"
            >
            </el-input>
          </el-form-item>
          <on-Upload
            @fileDataSingle="val => fileDataSingle(val, index)"
            :fileList="item.mateFiles"
            label-width="165px"
            labelName="物资附件"
            accept=".doc,.docx,.txt,.xls,.xlsx,.pdf"
            :limit="3"
            :checkFlag="pageTypeCheck"
          ></on-Upload>
        </div>
        <div class="add" @click="onAdd" v-if="!pageTypeCheck">
          +添加处置物资
        </div>
        <div class="title-little-subheading">委托处置信息</div>
        <el-form-item label="委托标题" style="width:80%" prop="title">
          <span v-if="pageTypeCheck">{{ form.title }}</span>
          <el-input v-model="form.title" v-else></el-input>
        </el-form-item>
        <el-form-item label="物资类型" prop="assetClass" ref="assetClass">
          <el-radio
            v-model="form.assetClass"
            :label="1"
            @change="onAssetClass"
            v-if="!pageTypeCheck"
            >废旧物资</el-radio
          >
          <el-radio
            v-model="form.assetClass"
            :label="2"
            @change="onAssetClass"
            v-if="!pageTypeCheck"
            >闲置物资</el-radio
          >
          <span v-else>{{
            form.assetClass == 1 ? '废旧物资' : '闲置物资'
          }}</span>
        </el-form-item>
        <el-form-item label="服务范围">
          <span>竞价服务</span>
        </el-form-item>
        <div
          style="width:85%;margin:0 auto;border:1px solid #DCDFE6;border-radius: 5px;padding:20px;line-height:25px;margin-bottom:20px"
        >
          <span
            ><span style="font-weight: 600;">竞价服务:</span>
            竞价准备到竞价结束的线上、线下处置服务，服务内容含对处置物资分类标识、为编制处置方案提供决策依据、编制竞价公告、购买商资质审核、组织现场踏勘、协助签订买卖合同。</span
          >
        </div>
        <p class="tips" v-if="accountStatus !== 'auth'">
          线上支付货款收款方式需要开通在线支付功能，如有疑问，请致电：400-819-8786。
        </p>
        <el-row>
          <el-col :span="12">
            <el-form-item label="货款收款方式" prop="payMethod">
              <span v-if="pageTypeCheck">{{
                form.payMethod == 1 ? '线下支付' : '线上支付'
              }}</span>
              <el-select
                v-model="form.payMethod"
                placeholder="请选择"
                @change="
                  val => {
                    if (val == 1) {
                      form.payPercentage = ''
                    }
                  }
                "
                v-if="!pageTypeCheck"
              >
                <el-option
                  :disabled="accountStatus !== 'auth'"
                  label="线上支付"
                  :value="2"
                ></el-option>
                <el-option label="线下支付" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="预收货款比例 :"
              prop="payPercentage"
              v-if="form.payMethod == 2"
            >
              <template slot="label">
                预收货款比例 :
                <el-tooltip effect="light" placement="top-start">
                  <template slot="content">
                    预收货款占成交总金额的比例
                  </template>
                  <i class="el-icon-question table-worming">&nbsp;</i>
                </el-tooltip>
                :
              </template>
              <span v-if="pageTypeCheck">{{
                form.payPercentage == 1
                  ? '100%'
                  : form.payPercentage == 1.1
                  ? '110%'
                  : form.payPercentage == 1.2
                  ? '120%'
                  : form.payPercentage == 1.3
                  ? '130%'
                  : ''
              }}</span>
              <el-select
                v-model="form.payPercentage"
                placeholder="请选择"
                v-else
              >
                <el-option label="100%" :value="1"></el-option>
                <el-option label="110%" :value="1.1"></el-option>
                <el-option label="120%" :value="1.2"></el-option>
                <el-option label="130%" :value="1.3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="entrustEndTime" label="委托截止日期">
          <span v-if="pageTypeCheck">{{ form.entrustEndTime }}</span>
          <el-date-picker
            v-else
            size="small"
            v-model="form.entrustEndTime"
            type="date"
            placeholder="选择日期时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="服务要求">
          <span v-if="pageTypeCheck">{{ form.serveRequirement }}</span>
          <el-input
            v-else
            type="textarea"
            :rows="3"
            maxlength="300"
            show-word-limit
            v-model="form.serveRequirement"
          >
          </el-input>
        </el-form-item>
        <on-Upload
          @fileDataSingle="val => serveRequirementFilesData(val)"
          :fileList="form.serveRequirementFiles"
          label-width="165px"
          labelName="服务要求附件"
          accept=".doc,.docx,.txt,.xls,.xlsx,.pdf"
          :checkFlag="pageTypeCheck"
        ></on-Upload>
        <div class="title-little-subheading">
          说明与附件（内部审批使用，不在发布的公告中展示）
        </div>
        <el-form-item label="说明">
          <span v-if="pageTypeCheck">{{ form.remark }}</span>
          <el-input
            v-else
            type="textarea"
            :rows="3"
            maxlength="300"
            show-word-limit
            v-model="form.remark"
          >
          </el-input>
        </el-form-item>
        <on-Upload
          @fileDataSingle="planFilesData"
          :fileList="form.planFiles"
          label-width="165px"
          labelName="附件"
          accept=".doc,.docx,.txt,.xls,.xlsx,.pdf"
          :checkFlag="pageTypeCheck"
        ></on-Upload>
        <div class="title-little-subheading">
          经办人
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contName">
              <span v-if="pageTypeCheck">{{ form.contName }}</span>
              <el-input v-model="form.contName" v-else></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机" prop="contMobile">
              <span v-if="pageTypeCheck">{{ form.contMobile }}</span>
              <el-input v-model="form.contMobile" v-else></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电话" prop="contPhone">
              <span v-if="pageTypeCheck">{{ form.contPhone }}</span>
              <el-input v-model="form.contPhone" v-else></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="contEmail">
              <span v-if="pageTypeCheck">{{ form.contEmail }}</span>
              <el-input v-model="form.contEmail" v-else></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        :model="formAudit"
        ref="formAudit"
        label-width="165px"
        v-if="pageConfim"
      >
        <div class="title-little-subheading">
          审批
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="审批结论:"
              :rules="[
                { required: true, message: '请选择审批结论', trigger: 'blur' }
              ]"
              prop="agreeFlag"
              ref="agreeFlag"
            >
              <el-radio
                v-model="formAudit.agreeFlag"
                label="1"
                @change="onAgreeFlag"
                >通过</el-radio
              >
              <el-radio
                v-model="formAudit.agreeFlag"
                label="0"
                @change="onAgreeFlag"
                >不通过</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="审批意见:"
          :rules="[
            {
              required: formAudit.agreeFlag === '0',
              message: ' ',
              trigger: 'blur'
            }
          ]"
          prop="message"
        >
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="formAudit.message"
            maxlength="300"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div v-if="tableData && tableData.length != 0">
        <div class="title-little-subheading">
          审批记录
        </div>
        <ConfimTable :tableData="tableData"></ConfimTable>
      </div>

      <div class="page-index-footer">
        <el-button
          type="primary"
          @click="submit(1)"
          :loading="loadingsubmit"
          v-if="!pageTypeCheck || pageConfim"
          >提交</el-button
        >
        <el-button
          @click="submit(0)"
          :loading="loadingsubmit"
          v-if="!pageTypeCheck"
          >保存</el-button
        >
        <el-button
          @click="onCancel"
          :loading="loadingsubmit"
          v-if="!pageTypeCheck || pageConfim"
          >取消</el-button
        >
        <el-button @click="onCancelClose" v-if="pageTypeCheck && !pageConfim"
          >关闭</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
export default {
  data() {
    return {
      form: {
        title: '',
        assetClass: '',
        payPercentage: '',
        entrustEndTime: '',
        serveRequirement: '',
        serveRequirementFiles: [],
        remark: '',
        contEmail: '',
        contMobile: '',
        contName: '',
        contPhone: '',
        planFiles: [],
        sellerMateVOList: [
          {
            Video: '',
            majorImageId: '',
            fixedMateAmount: null,
            unitName: '吨',
            classNamearr: [],
            className: '',
            mateFiles: [],
            mateVideos: [],
            mateAmount: '',
            mateName: '',
            mateDescribe: '',
            mateImgs: []
          }
        ]
      },
      accountStatus: '',
      loadingsubmit: false,
      classNamearrOptions: [],
      hicodeClassCodeist: [],
      isEnlargeImage: false,
      enlargeImage: '',
      unitOptions: [
        {
          value: '选项1',
          label: '吨'
        },
        {
          value: '选项2',
          label: '公斤'
        },
        {
          value: '选项3',
          label: '批'
        },
        {
          value: '选项4',
          label: '台'
        },
        {
          value: '选项5',
          label: '个'
        },
        {
          value: '选项6',
          label: '米'
        }
      ],
      FormRules: {
        payPercentage: [{ required: true, message: ' ', trigger: 'blur' }],
        payMethod: [{ required: true, message: ' ', trigger: 'change' }],
        title: [{ required: true, message: ' ', trigger: 'blur' }],
        entrustEndTime: [{ required: true, message: ' ', trigger: 'change' }],
        assetClass: [
          { required: true, message: '请选择物资类型', trigger: 'change' }
        ],
        contMobile: [
          {
            required: true,
            message: '请输入正确的手机号',
            pattern: /^1[0-9]{10}$/,
            trigger: 'blur'
          }
        ],
        contEmail: [
          {
            required: false,
            message: '请输入正确的邮箱地址',
            type: 'email',
            trigger: 'blur'
          }
        ],
        contName: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      formAudit: {
        agreeFlag: '',
        message: ''
      },
      tableData: []
    }
  },
  computed: {
    pageTypeCheck() {
      return this.$route.query.pageType == 'check'
    },
    pageConfim() {
      return this.$route.query.confim == 'confim'
    }
  },
  created() {
    this.hicode()
    this.getAccountStatus()
    if (
      this.$route.query.pageType == 'modify' ||
      this.$route.query.pageType == 'check'
    ) {
      this.getPlan()
    }
    if (this.pageTypeCheck) {
      this.FormRules = {}
    }
  },
  methods: {
    async getPlan() {
      let params = {
        id: this.$route.query.id
      }
      let data = await this.$api.materialdisposal.getPlan(params)
      console.log(data)
      this.form = {
        ...this.form,
        ...data,
        sellerMateVOList: data.sellerMateInfoVOList,
        sellerMateInfoVOList: null
      }
      this.form.sellerMateVOList.map(item => {
        item.mateImgs.map(item1 => {
          item1.src = config.STATIC_URL + item1.fileWebpath
          console.log(item1)
        })
        if (item.mateVideos.length !== 0) {
          item.Video = item.mateVideos[0].fileUrl
          item.mateVideos[0].src =
            config.STATIC_URL + item.mateVideos[0].fileWebpath
        }
      })
      if (this.form.workflowId) {
        this.reviewHis()
      }
      this.hicodeClassCodefun()
    },
    async onMateName(mateName) {
      let checkHazard = await this.$api.materialdisposal.checkHazard({
        names: mateName
      })
      console.log(checkHazard)
    },
    onAdd() {
      this.form.sellerMateVOList.push({
        Video: '',
        majorImageId: '',
        fixedMateAmount: null,
        unitName: '吨',
        classNamearr: [],
        className: '',
        mateFiles: [],
        mateVideos: [],
        mateAmount: '',
        mateName: '',
        mateDescribe: '',
        mateImgs: []
      })
    },
    onAssetClass() {
      this.$refs.assetClass.clearValidate()
    },
    handleFileEnlarge(url) {
      //放大图片
      if (url) {
        this.enlargeImage = url
        this.isEnlargeImage = !this.isEnlargeImage
      }
    },
    Videodelete(index) {
      this.form.sellerMateVOList[index].mateVideos = []
      this.form.sellerMateVOList[index].Video = ''
    },
    handleFileRemove(index, index1) {
      //删除图片
      if (
        this.form.sellerMateVOList[index].mateImgs[index1].fileId ===
        this.form.sellerMateVOList[index].majorImageId
      ) {
        this.form.sellerMateVOList[
          index
        ].majorImageId = this.form.sellerMateVOList[index].mateImgs[0].fileId
      }
      this.form.sellerMateVOList[index].mateImgs.splice(index1, 1)
      if (this.form.sellerMateVOList[index].mateImgs.length === 1) {
        this.form.sellerMateVOList[
          index
        ].majorImageId = this.form.sellerMateVOList[index].mateImgs[0].fileId
      }
    },
    onAgreeFlag() {
      this.$refs.agreeFlag.clearValidate()
    },
    onTitlesplic(index) {
      this.$confirm(`确定删除处置物资${index + 1}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.form.sellerMateVOList.splice(index, 1)

          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
        .catch(() => {})
    },
    fileDataSingle(val, index) {
      this.form.sellerMateVOList[index].mateFiles = val
    },
    serveRequirementFilesData(val) {
      this.form.serveRequirementFiles = val
    },
    planFilesData(val) {
      this.form.planFiles = val
    },
    async reviewHis() {
      let data = await this.$api.materialdisposal.reviewHisAndWait(
        this.form.workflowId
      )
      this.tableData = data.data
    },
    handleUploadForm(param, index) {
      let testmsg = param.file.name.substring(
        param.file.name.lastIndexOf('.') + 1
      )
      if (
        testmsg === 'mp4' ||
        testmsg === 'qlv' ||
        testmsg === 'qsv' ||
        testmsg === 'ogg' ||
        testmsg === 'flv' ||
        testmsg === 'avi' ||
        testmsg === 'wmv' ||
        testmsg === 'rmvb'
      ) {
        this.upload(param, index)
      } else {
        this.$message.error(
          '只可以上传avi、wmv、mpeg、mp4、mov、mkv、flv、rmv格式视频'
        )
      }
    },
    async upload(param, index) {
      let form = new FormData()
      form.append('file', param.file)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let data = await this.$api.common.fileUpload(form)
      loading.close()

      if (data) {
        this.form.sellerMateVOList[index].mateVideos = []
        data.name = data.fileName
        // this.Video = data.fileUrl
        data.src = config.STATIC_URL + data.fileWebpath
        this.form.sellerMateVOList[index].Video = data.fileUrl
        this.form.sellerMateVOList[index].mateVideos.push(data)
      }
    },
    // 获取当前企业是否开通在线支付
    async getAccountStatus() {
      const res = await this.$api.common.getAccountInfo({})
      this.accountStatus = res.accountStatus
      // 公司是否开户 frozen：冻结,auth：已开通,ccling:注销中,cancel:注销, 其他:查询失败
    },
    handleExceed() {
      this.$message.warning('最多上传10张图片')
    },
    handleUploadFormImgs(param, index) {
      if (this.form.sellerMateVOList[index].mateImgs.length === 10) {
        this.$message.error('最多上传10张图片')
        return false
      }
      let testmsg = param.file.name.substring(
        param.file.name.lastIndexOf('.') + 1
      )
      const isJPEG = testmsg.toUpperCase() === 'jpeg'.toUpperCase()
      const isJPG = testmsg.toUpperCase() === 'jpg'.toUpperCase()
      const isPNG = testmsg.toUpperCase() === 'png'.toUpperCase()
      const isBmp = testmsg.toUpperCase() === 'bmp'.toUpperCase()
      const isLt10M = param.file.size / 1024 / 1024 < 5
      if (!isJPG && !isPNG && !isBmp && !isJPEG) {
        this.$message.error('图片上传格式不正确请重新上传')
      } else if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      } else {
        this.uploadImgs(param, index)
      }
    },
    async uploadImgs(param, index) {
      let form = new FormData()
      form.append('file', param.file)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let data = await this.$api.common.fileUpload(form)
      loading.close()
      if (data) {
        if (this.form.sellerMateVOList[index].mateImgs.length === 0) {
          this.form.sellerMateVOList[index].majorImageId = data.fileId
        }
        data.src = config.STATIC_URL + data.fileWebpath
        this.form.sellerMateVOList[index].mateImgs.push(data)
      }
    },
    //所属分类
    async hicode() {
      let data = await this.$api.materialdisposal.hicode({
        classCode: 'WZCZ_MATES'
      })
      this.hicodeClassCodeist = data.data
      if (data) {
        let obj1 = []
        let obj2 = []
        // let obj3 = []
        data.data.map(item => {
          if (item.codeHierarchy === 1) {
            let objnoe = {
              value: item.codeCode,
              label: item.codeName
            }
            obj1.push(objnoe)
          }
          if (item.codeHierarchy === 2) {
            let objtwo = {
              value: item.codeCode,
              label: item.codeName
            }
            obj2.push(objtwo)
          }
        })
        obj1.map(item => {
          item.children = []
          obj2.map(item1 => {
            if (item.value === item1.value.substring(0, 2)) {
              item.children.push(item1)
            }
          })
        })
        const newArr = obj1.map(item => {
          if (item.children.length) {
            // item.disabled = true
          }
          return item
        })
        console.log(newArr)
        this.classNamearrOptions = newArr
      }
    },
    handleChangeoptions(item, index) {
      let nodd = this.$refs.cascaderUnit[index].getCheckedNodes()[0]
      item.classCode = nodd.value
      item.className = nodd.pathLabels.join('/')
    },
    async onMateTemplate() {
      let res = await this.$api.materialdisposal.mateTemplate()
      let blob = new Blob([res], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      let fileName = `外置物资导入模板`
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      link.click()
      link.remove()
      URL.revokeObjectURL(link.href)
    },
    async onRequest(params) {
      let form = new FormData()
      form.append('file', params.file)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let res = await this.$api.materialdisposal.importMate(form)
      loading.close()
      console.log(typeof res[0])
      if (res && res.length != 0) {
        if (typeof res[0] == 'string') {
          this.leadlList = res
          this.dialogVisiblelead = true
        } else {
          this.$message.success('导入成功')
          this.form.sellerMateVOList = res.map(item => {
            return {
              Video: '',
              majorImageId: '',
              unitName: '吨',
              classNamearr: [],
              className: '',
              mateFiles: [],
              mateVideos: [],
              mateAmount: '',
              mateName: '',
              mateDescribe: '',
              mateImgs: [],
              ...item,
              fixedMateAmount: item.mateAmount
            }
          })
          this.hicodeClassCodefun()
        }
      }
    },
    hicodeClassCodefun() {
      this.hicodeClassCodeist.map(item => {
        this.form.sellerMateVOList.map(item1 => {
          if (
            item1.classCode.length === 2 &&
            item.codeCode == item1.classCode
          ) {
            item1.classNamearr = [item.codeCode]
          } else if (
            item1.classCode.length > 2 &&
            item.codeCode == item1.classCode
          ) {
            item1.classNamearr = [item.codeCode.slice(0, 2), item.codeCode]
          }
        })
      })
    },
    onCancel() {
      this.$router.go(-1)
    },
    onCancelClose() {
      this.$closeCurrentPage()
    },
    submit(val) {
      if (this.pageConfim) {
        this.$refs.formAudit.validate(valid => {
          if (valid) {
            console.log(this.form)
            this.taskDoReview(val)
          } else {
            console.log(this.form)
          }
        })
      } else {
        this.$refs.form.validate(valid => {
          if (valid) {
            console.log(this.form)
            this.savePlan(val)
          } else {
            console.log(this.form)
          }
        })
      }
    },
    async savePlan(val) {
      let arr = []
      this.form.sellerMateVOList.map(item => {
        arr.push(item.mateName)
      })
      let arr1 = arr.join(',')
      this.loadingsubmit = true
      let checkHazard = await this.$api.materialdisposal.checkHazard({
        names: arr1
      })
      if (checkHazard) {
        let params = {
          ...this.form,
          status: val
        }

        let data = await this.$api.materialdisposal.savePlan(params)
        this.loadingsubmit = false
        if (data) {
          this.$message.success('提交成功')
          this.$router.go(-1)
        }
      } else {
        this.loadingsubmit = false
      }
    },
    async taskDoReview() {
      let obj = {
        workflowId: this.form.workflowId,
        ...this.formAudit,
        id: this.form.id
      }
      this.loadingsubmit = true
      let data = await this.$api.materialdisposal.taskDoReview(obj)
      this.loadingsubmit = false
      if (data) {
        this.$message.success('提交成功')
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.titleone {
  margin: 5px;
  width: 8px;
  height: 22px;
  background: #2587ff;
  float: left;
  border-radius: 2px;
}
.title {
  padding: 10px;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
  background: #ecf5ff;
  font-size: 15px;
  line-height: 15px;
}
.titlesplic {
  float: right;
  color: royalblue;
  cursor: pointer;
}
.add {
  width: 95%;
  height: 40px;
  border: 1px #2587ff dashed;
  text-align: center;
  color: royalblue;
  padding: 10px;
  margin-left: 50px;
  margin-bottom: 20px;
  cursor: pointer;
}
/deep/.el-upload--picture-card {
  margin-top: 10px;
  height: 80px !important;
  width: 90px !important;
  line-height: 89px !important;
}
.avatar-uploader .el-upload:hover {
  border: 1px dashed #d9d9d9 !important;
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 160px;
  height: 108px;
  line-height: 108px;
  text-align: center;
  border: 1px rgb(158, 158, 160) dashed;
}
.avatar {
  width: 100px;
  height: 108px;
  display: block;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  position: relative !important;
  overflow: hidden !important;
}
.img-list {
  width: 100%;
}
.img-list .img-content {
  position: relative;
  display: inline-block;
  width: 130px;
  height: 80px;
  margin: 10px 10px 20px 10px;
  border: 1px solid #d1dbe5;
  border-radius: 4px;
  transition: all 0.3s;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}
.img-list .img-content img {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-bottom: 2px;
  border-radius: 4px;
}
.img-list .img-content .name {
  margin-top: 10px;
}
.img-list .img-content .name > div {
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 25px;
  line-height: 25px;
}
.img-list .img-content:hover .del,
.img-list .img-content:hover .layer {
  opacity: 1;
}
.img-list .img-content .del,
.img-list .img-content .layer {
  opacity: 0;
  transition: all 0.3s;
}
.img-list .img-content .del {
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: #8492a6;
  cursor: pointer;
  font-size: 1.1em;
}
.img-list .img-content .layer {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 80px;
  color: #fff;
  text-align: center;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.4);
}
.img-list .img-content .layer i {
  font-size: 1.6em;
  margin-top: 80px;
}

.group {
  float: left;
}
.text {
  font-size: 10px;
  vertical-align: middle;
}
.tips {
  font-size: 12px;
  color: red;
  text-indent: 63px;
  margin-bottom: 5px;
}
</style>
